import { Box, Grid, Typography, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import { TRADE_SIDE } from "pages/BasicTrade/components/constants";

function FutureMobileBox({ item }) {
  return (
    <HistoryBoxWrapper side={item?.sideId}>
      <Grid container>
        <Grid item xs={6}>
          <Typography
            color="text.secondary"
            variant="subtitle2"
            textAlign="right"
          >
            {item?.date}
          </Typography>
          <Typography
            color="text.secondary"
            variant="subtitle2"
            textAlign="right"
          >
            {item?.time}
          </Typography>
        </Grid>
      </Grid>

      <Grid container mt={1} spacing={1}>
        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Side
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.main"
              fontWeight={400}
            >
              {item?.side}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Symbol
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.symbol}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Entry Price
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.entryPrice || 0} />{" "}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Leverage
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.leverage || 0} />{" "}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Liquidation Price
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.liquidationPrice || 0} />{" "}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Mark Price
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.markPrice || 0} />{" "}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Position Amount
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.positionAmount || 0} />{" "}

          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Position Total
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.positionTotal} />{" "}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Unrealized Profit
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.unRealizedProfit} />{" "}
          </Typography>
        </Grid>
      </Grid>
    </HistoryBoxWrapper>
  );
}

const HistoryBoxWrapper = styled(Box)(({ side, theme }) => ({
  background:
    side === TRADE_SIDE.Buy.id
      ? theme.palette.background.successGradient
      : theme.palette.background.errorGradient,
  border: `1px solid ${theme.palette.modules.border}`,
  borderRadius: "8px",
  padding: theme.spacing(1),
}));

export default FutureMobileBox;
